




































































































declare var window: any;
import { Vue, Component } from 'vue-property-decorator';
import Container from './Registration/Container.vue';
import RegistrationCard from './Registration/v2/Card.vue';
import CardHeader from './Registration/Header.vue';
import { vxm } from '../store.vuex';
import { OtpValidationToken } from '../models/userdata/otptoken';
import { VerificationError } from '@/models/userdata/verificationerror';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class Login extends Vue {
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private errors = new VerificationError();
  private numberErrors = {
    phone: '',
  };
  public phone: string = '';
  $wlToastr: any;
  private phoneEdit: boolean = false;
  private phoneNumber: string = '';
  private phoneNumberValid: boolean = false;
  private mobileNumber: string = '';
  private country: string = '';

  updateVerificationOtpPhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    // this.phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.phone = event.nationalNumber;
    this.phoneNumberValid = event.isValid;
    this.country = event.countryCallingCode;
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }
  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }

  mounted() {
    this.phoneNumber = vxm.users.myUserProfile.phoneNum;
  }

  editPhone() {
    this.phoneEdit = true;
  }

  submitChangePhone() {
    if (this.phone.length !== 10 || isNaN(Number(this.phone))) {
      this.numberErrors.phone = 'signup.phone.valid';
      return;
    }
    let companycode = vxm.jobs.BrandingInfo.companycode;
    let phoneNumber = this.phone;
    let countryCode = '+1';
    //console.log('country code:'+this.country);
    countryCode = encodeURIComponent('+' + this.country);
    //countryCode = encodeURIComponent(countryCode);
    let email = encodeURIComponent(vxm.users.myUserProfile.email);
    const changeNumberCount = '1';
    let url = `/wl-sso-sec-svc/api/user/changeNumber?companycode=${companycode}&email=${email}&phone=${phoneNumber}&changeNumberCount=${changeNumberCount}&countrycode=${countryCode}`;
    vxm.users.changeNumber(url).then((resp) => {
      if (resp.status === 'success') {
        this.phoneEdit = false;
        this.phoneNumber = resp.phone;
        this.$wlToastr(
          'info',
          this.$t('new-verification-code-sent'),
          this.$t('changenumber.toast.title'),
        );
      } else {
        this.$wlToastr(
          'error',
          this.$t('ph-number-change-err-msg'),
          this.$t('changenumber.toast.title'),
        );
      }
    });
  }

  resendEventHandler() {
    vxm.users.sendOTP().then((value) => {
      if (value.status === 'success') {
        this.$wlToastr(
          'info',
          this.$t('resent-otp-success-msg'),
          this.$t('verification.toast.title'),
        );
      } else {
        const errorMessage = value.error;
        this.$wlToastr(
          'error',
          errorMessage,
          this.$t('verification.toast.title'),
        );
      }
    });
  }
  validateOtp() {
    this.errors.otpToken = '';
    if (!this.otpToken.otp || this.otpToken.otp.length < 5) {
      this.errors.otpToken = this.$t('verification.otp.validation.message');
      return false;
    } else {
      return true;
    }
  }
  continueOTP() {
    vxm.users.setNewUser(true);
    if (!this.validateOtp()) {
      return;
    }
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myUserProfile.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    if (vm.isLoggedIn) {
      vxm.users.validateOTP(vm.otpToken).then((value) => {
        if (value.status === 'success') {
          vm.$wlToastr(
            'success',
            vm.$t('verfication.otp.success'),
            vm.$t('verification.toast.title'),
          );
        } else {
          vm.errors.otpToken = value.error;
        }
      });
    } else {
      vxm.users.anonValidateOTP(vm.otpToken).then((value) => {
        if (value.status === 'success') {
          vm.$wlToastr(
            'success',
            vm.$t('verfication.otp.success'),
            vm.$t('verification.toast.title'),
          );
        } else {
          vm.errors.otpToken = value.error;
        }
      });
    }
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  skipVerification() {
    vxm.users.setNewUser(true);
    let homePage: any;
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      homePage = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (route) => route.sectionKey === 'HOME',
      );
    } else {
      homePage = vxm.jobs.BrandingInfo.leftMenu.slideMenuOptions.find(
        (route) => route.alias === 'home',
      );
    }
    const url = this.$cookies.get('NavigateTo_ID');
    const arr = url ? url.split(':') : url;
    const submitJobApplicationId = this.$cookies.get('SubmitJobApplicationId');
    this.$cookies.remove('SubmitJobApplicationId');
    if (url && submitJobApplicationId) {
      const jobID = parseInt(arr[1], 10);
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: jobID + '' },
      });
      return;
    } else if (
      vxm.utility.IsNewlyRegisteredUser &&
      vxm.configs.GuidedSignupEnabled
    ) {
      this.$router.push({ name: 'GuidedSignup' });
      return;
    } else if (url) {
      const [, id] = url.split(':');
      this.$router.push({
        name: 'Jobdetails',
        params: { JobID: id },
      });
      this.$cookies.remove('NavigateTo_ID');
      return;
    }
    if (homePage && homePage.signInVisibility) {
      this.$router.push({ name: 'Home' });
      return;
    }
    this.$router.push({ name: 'Findjobs' });
  }
}
